import type { Branch, NavLink } from "@app-types/index";

export const company = {
  name: "Pomilio & Asociados",
  fullName: "Pomilio & Asociados Seguros",
  shortName: "Pomilio",
  tagline: "Asesoría personalizada en seguros, sin respuestas automáticas.",
  description:
    "Organización de seguros con productores asesores capacitados para acompañarte en cada decisión: cobertura, siniestros y renovaciones.",
  phone: "11 2193 9794",
  phoneAlt: "11 2757 8048",
  whatsapp: "5491121939794",
  email: "pomilio.asociados@hotmail.com",
  hours: "Lunes a viernes, 9 a 18 hs",
  social: {
    instagram: "https://instagram.com/pomilioseguros",
    facebook: "https://facebook.com/pomilioseguros",
    linkedin: "https://linkedin.com/company/pomilioseguros",
  },
} as const;

export const branches: Branch[] = [
  {
    name: "Casa Central",
    address: "Ruta 8 9532, Km. Alt. 21",
    city: "Loma Hermosa, San Martín",
    mapUrl:
      "https://maps.google.com/?q=Ruta+8+9532+Km+21,+Loma+Hermosa,+San+Martín",
    phone: "11 2757 8048",
    phoneDial: "1127578048",
    hours: {
      weekdays: "9 a 12 y 13.30 a 18 hs",
      saturday: "9 a 12.30 hs",
    },
  },
  {
    name: "Sucursal San Miguel",
    address: "Ángel D'Elía 1759",
    city: "San Miguel, Buenos Aires",
    mapUrl: "https://maps.google.com/?q=Ángel+D'Elía+1759,+San+Miguel,+Buenos+Aires",
    phone: "11 2193 9794",
    phoneDial: "1121939794",
    hours: {
      weekdays: "9.30 a 12.30 y 13.30 a 17 hs",
      saturday: "9 a 12.30 hs",
    },
  },
];

export const navigation: NavLink[] = [
  { label: "Inicio", to: "/" },
  { label: "Nosotros", to: "/nosotros" },
  {
    label: "Productos",
    to: "/productos",
    children: [
      { label: "Automotor", to: "/productos#automotor" },
      { label: "Hogar", to: "/productos#hogar" },
      { label: "Vida", to: "/productos#vida" },
      { label: "Comercio", to: "/productos#comercio" },
      { label: "ART", to: "/productos#art" },
      { label: "Ver todos", to: "/productos" },
    ],
  },
  { label: "Preguntas Frecuentes", to: "/faq" },
  { label: "Contacto", to: "/contacto" },
];
